import React from 'react'

const Footer = () => {
  return (
    <div className='max-w-[1200px] sm:h-[150px] p-12 flex justify-between mx-auto'>
        <span className='primary-color'>Abdul Moeez Shaikh</span>
        <a className='text-gray-600' href="mailto:shaika97@mcmaster.ca">shaika97@mcmaster.ca</a>
    </div>
  )
}

export default Footer